import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsBasicStep.StepForm', {
    pleaseProvideDetails: 'Please provide information of all directors of the {companyName}.',
    additionallyPleaseProvide:
        'Additionally please provide information of any owner, whose sharehold is equal or more than 10% of your business (directly or through other entities).',
    addPerson: 'Add user',
    learnMore: 'Learn more',
});
